import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorActiveTaxWithholdingAccount = (
  internalAccount: InternalAccount
) =>
  internalAccount.type === "TaxWithholding" &&
  internalAccount.status === "Active";
